<app-base-overlay
  title="Pages"
  description="Reorder pages or choose which page to edit.">
  <div body class="flex flex-col gap-3">
    <div
      cdkDropList
      cdkDropListLockAxis="y"
      [cdkDropListData]="pages()"
      (cdkDropListDropped)="onDrop($event)"
      class="form-pages-overlay__list flex flex-col gap-2">
      @for (page of pages(); track page.id; let i = $index) {
        <div
          cdkDrag
          class="form-pages-overlay__row group flex items-center gap-2 rounded-xl border bg-white px-2 py-2"
          [class.border-primary-600]="page.id === activePageId()"
          [class.border-slate-200]="page.id !== activePageId()"
          [class.bg-primary-50]="page.id === activePageId()">
          <div *cdkDragPreview class="form-pages-overlay__preview">
            <p class="truncate text-sm font-semibold text-slate-900">
              {{ pageDisplayLabel(page, i) }}
            </p>
            <p class="mt-0.5 text-xs text-slate-500">
              {{ page.fields.length }} field{{ page.fields.length === 1 ? '' : 's' }}
            </p>
          </div>
          <div *cdkDragPlaceholder class="form-pages-overlay__placeholder"></div>

          <button
            type="button"
            cdkDragHandle
            class="inline-flex size-8 shrink-0 cursor-grab items-center justify-center rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600 active:cursor-grabbing"
            aria-label="Drag to reorder"
            (click)="$event.stopPropagation()">
            <app-svg-icon src="assets/icons/drag-vertical.svg" [size]="16" />
          </button>

          <button
            type="button"
            class="flex min-w-0 flex-1 cursor-pointer items-center gap-2 rounded-lg px-2 py-1.5 text-left hover:bg-white/70"
            (click)="selectPage(page.id)">
            <span class="min-w-0 flex-1">
              <p
                class="truncate text-sm"
                [class.font-semibold]="page.id === activePageId()"
                [class.text-slate-950]="page.id === activePageId()"
                [class.text-slate-800]="page.id !== activePageId()">
                {{ pageDisplayLabel(page, i) }}
              </p>
              <p class="mt-0.5 text-xs text-slate-500">
                {{ page.fields.length }} field{{ page.fields.length === 1 ? '' : 's' }}
              </p>
            </span>
            <svg
              class="h-4 w-4 shrink-0 text-slate-400"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true">
              <path
                d="M9 6l6 6-6 6"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
        </div>
      }
    </div>
  </div>

  <div actions class="flex flex-wrap justify-end gap-3">
    <lib-signal-button appearance="outline" [fullWidth]="false" (clicked)="close()">
      Cancel
    </lib-signal-button>
    <lib-signal-button [fullWidth]="false" (clicked)="done()">
      Done
    </lib-signal-button>
  </div>
</app-base-overlay>
